// extracted by mini-css-extract-plugin
export var avatarContainer = "_88-0";
export var avatarTypingWave = "_88-i";
export var gray = "_88-f";
export var green = "_88-c";
export var icon = "_88-9";
export var image = "_88-1";
export var lg = "_88-6";
export var md = "_88-5";
export var presenceDot = "_88-b";
export var red = "_88-d";
export var sm = "_88-4";
export var status = "_88-a";
export var typingDot = "_88-h";
export var typingPill = "_88-g";
export var xl = "_88-7";
export var xs = "_88-3";
export var xxl = "_88-8";
export var xxs = "_88-2";
export var yellow = "_88-e";